<template>
    <div>
        <!-- LOADINGBAR? -->
        <slot />
    </div>
</template>
